import { isRef, nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import type { Composer } from 'vue-i18n'
import enUS from '../locales/en-US.json'
import bs from '../locales/bs.json'
import sr from '../locales/sr.json'
import hr from '../locales/hr.json'
import ro from '../locales/ro.json'

type MessageSchema = typeof enUS

type SupportedLocales = 'en-US' | 'bs' | 'sr' | 'hr' | 'ro'

const i18n = createI18n<[MessageSchema], SupportedLocales>({
  legacy: false,
  globalInjection: true,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': enUS,
    bs: bs as MessageSchema,
    sr: sr as MessageSchema,
    hr: hr as MessageSchema,
    ro: ro as MessageSchema,
  },
})
const composer = i18n.global as unknown as Composer
const t: Composer['t'] = composer.t

const setI18nLanguage = (locale: string) => {
  if (isRef(composer.locale)) {
    composer.locale.value = locale
  }
}

const setTranslations = (translations: MessageSchema, locale: SupportedLocales = 'en-US') => {
  composer.setLocaleMessage(locale, translations)
  setI18nLanguage(locale)
  return nextTick()
}

export default i18n
export { setTranslations, t }
export type { MessageSchema }
